module.exports = __webpack_public_path__ + "img/Bestial-Mouths-no-logo.467862e4.jpg";